export default __webpack_public_path__ + "static/media/luna.58e52ff4.gif";